import { render, staticRenderFns } from "./SaveCancelButtons.vue?vue&type=template&id=72a0f69d&scoped=true"
import script from "./SaveCancelButtons.vue?vue&type=script&lang=js"
export * from "./SaveCancelButtons.vue?vue&type=script&lang=js"
import style0 from "./SaveCancelButtons.vue?vue&type=style&index=0&id=72a0f69d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a0f69d",
  null
  
)

export default component.exports